module.exports = __webpack_public_path__ + "img/send.d92b5df5.svg";